<template>
	<div class="grid">
		<Toast />
		<div class="col-12">
			<Breadcrumb :home="breadcrumbHome" :model="breadcrumbItems" />
		</div>

		<div class="col-12 p-fluid mb-4">
			<div class="content-wrapper">
				<div class="content-header">
					<span class="font-bold text-xl">SPE Report Outstanding</span>
				</div>
				<div class="content-body">
					<TabView v-model:activeIndex="activeTab" @tab-change="onTabChange">
						<!-- TAB 1: BACKLOG -->
						<TabPanel header="Backlog">
							<div class="grid">
								<div class="col-12">
									<DataTable
										dataKey="spe_id"
										responsiveLayout="scroll"
										:lazy="true"
										:paginator="true"
										:rows="10"
										:rowsPerPageOptions="[5, 10, 20, 50]"
										:loading="loading.backlog"
										:totalRecords="totalRecords.backlog"
										:value="dataList.backlog"
										:scrollable="true"
										scrollHeight="500px"
										scrollDirection="both"
										paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
										currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
										@page="onPage($event, 'backlog')"
									>
										<Column header="No SPE" field="spe_no" style="min-width: 130px" />
										<Column header="Supplier" field="vendor_name" style="min-width: 200px" />
										<Column header="Company" field="company_name" style="min-width: 180px" />
										<Column header="Period" field="period_name" style="min-width: 120px" />
										<Column header="Grade" field="grade_name" style="min-width: 100px" />
										<Column header="Created Date" field="created_at" style="min-width: 150px">
											<template #body="{ data }">
												{{ formatDate(data.created_at) }}
											</template>
										</Column>
										<Column header="Due Date" field="due_date" style="min-width: 150px">
											<template #body="{ data }">
												{{ formatDate(data.due_date) }}
											</template>
										</Column>
										<Column header="Status" style="min-width: 120px">
											<template #body="{ data }">
												<Chip
													class="custom-chip"
													:class="`chip-${(data.status_name || '').toLowerCase()}`"
												>
													{{ data.status_name }}
												</Chip>
											</template>
										</Column>
										<Column header="Action" style="min-width: 100px">
											<template #body="{ data }">
												<Button
													icon="pi pi-eye"
													class="p-button-rounded p-button-text"
													@click="goToDetail(data.spe_id)"
													v-tooltip.top="'View Detail'"
												/>
											</template>
										</Column>
										<template #empty>
											<div class="text-center py-4 text-gray-500">No backlog reports found.</div>
										</template>
									</DataTable>
								</div>
							</div>
						</TabPanel>

						<!-- TAB 2: IN PROGRESS -->
						<TabPanel header="In Progress">
							<div class="grid">
								<div class="col-12">
									<DataTable
										dataKey="spe_id"
										responsiveLayout="scroll"
										:lazy="true"
										:paginator="true"
										:rows="10"
										:rowsPerPageOptions="[5, 10, 20, 50]"
										:loading="loading.inProgress"
										:totalRecords="totalRecords.inProgress"
										:value="dataList.inProgress"
										:scrollable="true"
										scrollHeight="500px"
										scrollDirection="both"
										paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
										currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
										@page="onPage($event, 'inProgress')"
									>
										<Column header="No SPE" field="spe_no" style="min-width: 130px" />
										<Column header="Supplier" field="vendor_name" style="min-width: 200px" />
										<Column header="Company" field="company_name" style="min-width: 180px" />
										<Column header="Period" field="period_name" style="min-width: 120px" />
										<Column header="Grade" field="grade_name" style="min-width: 100px" />
										<Column header="Created Date" field="created_at" style="min-width: 150px">
											<template #body="{ data }">
												{{ formatDate(data.created_at) }}
											</template>
										</Column>
										<Column header="Due Date" field="due_date" style="min-width: 150px">
											<template #body="{ data }">
												{{ formatDate(data.due_date) }}
											</template>
										</Column>
										<Column header="Status" style="min-width: 120px">
											<template #body="{ data }">
												<Chip
													class="custom-chip"
													:class="`chip-${(data.status_name || '').toLowerCase()}`"
												>
													{{ data.status_name }}
												</Chip>
											</template>
										</Column>
										<Column header="Action" style="min-width: 100px">
											<template #body="{ data }">
												<Button
													icon="pi pi-eye"
													class="p-button-rounded p-button-text"
													@click="goToDetail(data.spe_id)"
													v-tooltip.top="'View Detail'"
												/>
											</template>
										</Column>
										<template #empty>
											<div class="text-center py-4 text-gray-500">No in-progress reports found.</div>
										</template>
									</DataTable>
								</div>
							</div>
						</TabPanel>

						<!-- TAB 3: DONE -->
						<TabPanel header="Done">
							<div class="grid">
								<div class="col-12">
									<DataTable
										dataKey="spe_id"
										responsiveLayout="scroll"
										:lazy="true"
										:paginator="true"
										:rows="10"
										:rowsPerPageOptions="[5, 10, 20, 50]"
										:loading="loading.done"
										:totalRecords="totalRecords.done"
										:value="dataList.done"
										:scrollable="true"
										scrollHeight="500px"
										scrollDirection="both"
										paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
										currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
										@page="onPage($event, 'done')"
									>
										<Column header="No SPE" field="spe_no" style="min-width: 130px" />
										<Column header="Supplier" field="vendor_name" style="min-width: 200px" />
										<Column header="Company" field="company_name" style="min-width: 180px" />
										<Column header="Period" field="period_name" style="min-width: 120px" />
										<Column header="Grade" field="grade_name" style="min-width: 100px" />
										<Column header="Created Date" field="created_at" style="min-width: 150px">
											<template #body="{ data }">
												{{ formatDate(data.created_at) }}
											</template>
										</Column>
										<Column header="Due Date" field="due_date" style="min-width: 150px">
											<template #body="{ data }">
												{{ formatDate(data.due_date) }}
											</template>
										</Column>
										<Column header="Status" style="min-width: 120px">
											<template #body="{ data }">
												<Chip
													class="custom-chip"
													:class="`chip-${(data.status_name || '').toLowerCase()}`"
												>
													{{ data.status_name }}
												</Chip>
											</template>
										</Column>
										<Column header="Action" style="min-width: 100px">
											<template #body="{ data }">
												<Button
													icon="pi pi-eye"
													class="p-button-rounded p-button-text"
													@click="goToDetail(data.spe_id)"
													v-tooltip.top="'View Detail'"
												/>
											</template>
										</Column>
										<template #empty>
											<div class="text-center py-4 text-gray-500">No completed reports found.</div>
										</template>
									</DataTable>
								</div>
							</div>
						</TabPanel>
					</TabView>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { onMounted, ref, reactive } from 'vue';
import { useRouter } from 'vue-router';
import SpeReportService from '@/service/SpeReportService';

const router = useRouter();

// ─── Breadcrumb ───
const breadcrumbHome = ref({ icon: 'pi pi-home', to: '/dashboard' });
const breadcrumbItems = ref([
	{ label: 'SPE', to: '/mgm/master/spereport' },
	{ label: 'Report Outstanding', to: '' },
]);

// ─── Tabs ───
const activeTab = ref(0);
const TAB_STATUS_MAP = {
	backlog: ['Draft', 'New'],
	inProgress: ['On Progress', 'Review'],
	done: ['Done', 'Approved', 'Closed'],
};

// ─── State per tab ───
const dataList = reactive({
	backlog: [],
	inProgress: [],
	done: [],
});
const totalRecords = reactive({
	backlog: 0,
	inProgress: 0,
	done: 0,
});
const loading = reactive({
	backlog: false,
	inProgress: false,
	done: false,
});
const pagination = reactive({
	backlog: { page: 0, rows: 10 },
	inProgress: { page: 0, rows: 10 },
	done: { page: 0, rows: 10 },
});

const tabKeys = ['backlog', 'inProgress', 'done'];

// ─── Methods ───
function getTabKey(index) {
	return tabKeys[index] || 'backlog';
}

async function fetchData(tabKey) {
	const statusFilter = TAB_STATUS_MAP[tabKey] || [];
	const params = {
		page: pagination[tabKey].page + 1,
		limit: pagination[tabKey].rows,
	};
	const payload = { status_name: statusFilter };

	loading[tabKey] = true;
	try {
		const response = await SpeReportService.getReportList(params, payload);
		const result = response.data;
		dataList[tabKey] = result.data || [];
		totalRecords[tabKey] = result.total || result.data?.length || 0;
	} catch (err) {
		console.error(`[SpeReportOutstanding] Failed to fetch ${tabKey}:`, err);
		dataList[tabKey] = [];
		totalRecords[tabKey] = 0;
	} finally {
		loading[tabKey] = false;
	}
}

function onTabChange(event) {
	const tabKey = getTabKey(event.index);
	if (dataList[tabKey].length === 0) {
		fetchData(tabKey);
	}
}

function onPage(event, tabKey) {
	pagination[tabKey] = {
		page: event.page,
		rows: event.rows,
	};
	fetchData(tabKey);
}

function goToDetail(speId) {
	if (speId) {
		router.push({ name: 'DetailSpeReport', params: { id: speId } });
	}
}

function formatDate(dateStr) {
	if (!dateStr) return '-';
	const d = new Date(dateStr);
	return d.toLocaleDateString('id-ID', {
		year: 'numeric',
		month: 'short',
		day: 'numeric',
	});
}

// ─── Init ───
onMounted(() => {
	fetchData('backlog');
});
</script>

<style scoped>
.custom-chip {
	font-size: 0.8rem;
	padding: 0.3rem 0.6rem;
	border-radius: 4px;
	font-weight: 600;
}
.chip-draft {
	background: #ffeeba;
	color: #856404;
}
.chip-new {
	background: #cce5ff;
	color: #004085;
}
.chip-on progress {
	background: #fff3cd;
	color: #856404;
}
.chip-review {
	background: #d4edda;
	color: #155724;
}
.chip-done,
.chip-approved,
.chip-closed {
	background: #d4edda;
	color: #155724;
}
</style>
